import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navItems = [
    { name: '首页', path: '/' },
    { name: '恋爱', path: '/category/love' },
    { name: '悬疑', path: '/category/suspense' },
    { name: '奇幻', path: '/category/fantasy' },
    { name: '都市', path: '/category/urban' },
    { name: '关于我们', path: '/about' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <div className={`font-heading text-xl font-bold whitespace-nowrap ${scrolled ? 'text-foreground-900' : 'text-white'}`}>
              韩漫漫画网
            </div>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === item.path
                    ? scrolled
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-white/20 text-white'
                    : scrolled
                      ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className={`w-9 h-9 rounded-full flex items-center justify-center cursor-pointer transition-colors ${scrolled ? 'text-foreground-600 hover:bg-background-200' : 'text-white/80 hover:bg-white/10 hover:text-white'}`}>
              <i className="ri-search-line text-lg"></i>
            </button>
            <Link
              to="/category/love"
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                scrolled
                  ? 'bg-foreground-900 text-background-50 hover:bg-foreground-800'
                  : 'bg-white text-foreground-900 hover:bg-white/90'
              }`}
            >
              开始阅读
            </Link>
          </div>

          <button
            className={`md:hidden w-9 h-9 rounded-full flex items-center justify-center cursor-pointer ${scrolled ? 'text-foreground-700' : 'text-white'}`}
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === item.path
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:bg-background-200'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <div className="mt-2 pt-2 border-t border-background-200">
              <Link
                to="/category/love"
                className="block w-full text-center px-4 py-3 bg-foreground-900 text-background-50 rounded-full text-sm font-medium cursor-pointer"
              >
                开始阅读
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}